var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body my-gallery" },
        [
          _c("gallery", {
            attrs: {
              images: _vm.images,
              index: _vm.imgIndex,
              options: {
                closeOnEscape: true,
                closeOnSlideClick: true,
                closeOnSwipeUpOrDown: true,
                startSlideshow: true,
                fullScreen: false
              }
            },
            on: {
              close: function($event) {
                _vm.imgIndex = null
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "image-gallery" }, [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.images, function(image, bindex) {
                return _c(
                  "figure",
                  {
                    key: bindex,
                    staticClass: "col-xl-3 col-lg-4 col-md-6 col-xs-12"
                  },
                  [
                    _c("img", {
                      staticClass: "demo image img-fluid",
                      attrs: { src: image },
                      on: {
                        click: function($event) {
                          _vm.imgIndex = bindex
                        }
                      }
                    })
                  ]
                )
              }),
              0
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Image Gallery")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Gallery")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Image Gallery")
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76bb6e33", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bb6e33","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/gallery/ImageGallery.vue
// module id = 795
// module chunks = 0